<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="80px"
      class="demo-ruleForm"
    >
      <el-form-item label="数量" prop="num">
        <el-input-number
          v-model="ruleForm.num"
          controls-position="right"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <!--  <el-form-item label="仓库" prop="warehouseCategory">
        <el-input v-model="ruleForm.warehouseCategory"></el-input>
      </el-form-item> -->
      <el-form-item align="center">
        <el-button type="primary" @click="submitForm('ruleForm')">引用</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        num: "",
      },
      rules: {
        num: [{ required: true, message: "请输入数量", trigger: "blur" }],
        typeId: [{ required: true, message: "请选择耗材分类", trigger: "change" }],
      },
      typeList: [],
    };
  },
  props: ["item", "close", "isId", "id"],
  created() {},
  methods: {
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let q = that.item;
          q.num = 0;
          q.id = null;
          if (this.isId) {
            q.id = this.id;
          }
          $utils.api.load("/admin/system/inventory/addAdmin", q, "POST").then((res) => {
            if (res.code == 200) {
              that.$emit("close");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
